import { render, staticRenderFns } from "./DefectMonitorItem.vue?vue&type=template&id=720cec42&scoped=true&"
import script from "./DefectMonitorItem.vue?vue&type=script&lang=js&"
export * from "./DefectMonitorItem.vue?vue&type=script&lang=js&"
import style0 from "./DefectMonitorItem.vue?vue&type=style&index=0&id=720cec42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720cec42",
  null
  
)

export default component.exports